import comp from "./ColorSelector";
export default comp;
